import React from "react";

export default function FooterRughtText() {
  return (
    <div className="w-full md:w-1/2 mt-12 md:mt-0">
      <div className="text-left ">
        <p className="text-sm text-white pb-8">
          Loans Provided by Warp Speed Mortgage, a dba of CalCon Mutual Mortgage
          LLC
        </p>
        <p className="text-sm text-white">
          NMLS #46375 (
          <a
            href="https://www.nmlsconsumeraccess.org/"
            target="_blank"
            className="font-semibold"
          >
            www.nmlsconsumeraccess.org
          </a>
          ); 3838 Camino del Rio N Suite 305, San Diego, CA 92108. Corporate
          phone (877) 707-2050.
        </p>
        <p className="text-sm text-white ">
          For licensing information, go to:{" "}
          <a
            href="https://www.nmlsconsumeraccess.org/"
            target="_blank"
            className="font-semibold"
          >
            www.nmlsconsumeraccess.org
          </a>
        </p>
        <p className="text-sm text-white pb-8">
          © 2013 – 2021 Warp Speed Mortgage
        </p>
        <p className="text-sm text-white pb-8">
          By refinancing your existing loan, your total finance charges may be
          higher over the life of the loan. (Reference:{" "}
          <a
            href="https://law.lis.virginia.gov/admincode/title10/agency5/chapter160/section60/"
            target="_blank"
            className="font-semibold"
          >
            10 VAC 5-160-60 (F)
          </a>
          )
        </p>
        <p className="text-sm text-white">
          <a
            href="https://warpspeedmortgage.com/14-business-day-closing-guarantee/"
            target="_blank"
            className="font-semibold underline"
          >
            14 Day Closing Guarantee
          </a>
        </p>
      </div>
    </div>
  );
}
